import * as ReactDOM from 'react-dom';
import React, { Component, useState, useEffect,createElement  } from 'react';
import './common.css';
import Usersession from './Usersession';
import axios from 'axios';
import Configdata from './Defaultdata';
import chatlnpfp from './Userpfpc';
import usrf1 from './imgs/girlchair1.png';
import usrm1 from './imgs/boychair33.png';
import chair from './imgs/tallchairwb.png';
import {showhidediv,loadwidgate,clrwidgate,gtdfltvid,setdvl,fillmsg,insertpost} from './userdefaultdata';
import pusrf1 from './imgs/grlpfp.png';
import pusrm1 from './imgs/boypfp.png';
import {cleardv} from './clearmem';
import {Uprofile} from './Userprofile'; 
import Pvtmsgbox from './Pvtmsgbox';
import './spinner.css';
export const GetItemslist=(arr:any)=>{
let userchats =[
	{
mid:0,mitemname:'Test',mitemurl:"",mextention:''
,mitemtype: 1,msts: 0,mpointdeduct: 2,mitxt:""},
];
if(arr)	userchats = arr;	

return(
     <div className="per100">
      <div className="per100">
	 <div className="postinchat"  style={{overflowX:'hidden',overflowY:'auto',height:'75vh'}}>
	  <div className="per100" style={{height:'auto'}}>
                      <table className="msgusertbl">
			{userchats.map((row,index)=>(
                       
			<tr>
                       <td style={{width:'50%',height:'auto'}}>
                       <div style={{height:'100px',width:'95%'}} className="p-usr-itm-nm">
                         <span style={{height:'90px'}} > 
                              <div className="lds-circle"><div>
				{row.mitxt}
				</div></div> 
				   
                            </span>	
	  			
		         </div>
			</td>
			<td style={{width:'25%'}}>
                      <a href="#" className="blanka"  onClick={e=>Purchaseitmlst(e,row.mid,3,2)} title="20 points">
                        <div style={{width:'90%',height:'100px'}} className="p-usr-itm-tt">

		  	   {row.mpointdeduct} Points

             	       </div>
			</a>
                      
			</td>

			</tr>
                       
			))}
	   	    </table>
	 </div>	
        
	</div>
	
	</div>

     </div>
);

};
export const configpvtmsg=(arr:any)=>{
 //const chats = Userpmusers(arr);
 //alert(JSON.stringify(arr));
 if(cleardv('wigtarea')){
  const dv = document.getElementById('wigtarea') as HTMLElement;
  if(arr.length > 0)
  showhidediv(true,'chatprofiledivtop');
  dv.style.display='block'; 
 // ReactDOM.render(chats,dv);
 

 }
};

export const setitems=(opt:any)=>{
	 try {
         //const vid = localStorage.getItem("dvillaid");
	const vid = 1;

         const userid = Usersession.getUserId();
         const vtype = localStorage.getItem("vilaty");
	let  service ="/getchatmsg?cid="+vid+"&uid="+userid;
        if(vtype == '2')
	 service ="/getchatmsgp?cid="+vid+"&uid="+userid;


       //alert(service);	
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
              
		const tdata = response.data;
		configpvtmsg(tdata);
		
            })
            .catch((err: any) => {
            
            });

                
          }
        catch (e) {
            //debugger;
	
        }

	
     };	

 export const Purchaseitmlst=(e:any,id:any,tp:any,points:any)=> {
    
     const uid = Usersession.getUserId();
     const url = '/insertsaleitem';
    const data = {
		userid:uid,itemid:id,itmtypid:tp
		,pointrs:points,isgift:0,giftedid:0
		};
     
      insertpost(url,data);
     
    
    };

